'use strict';

angular.module('tencentImModule', []).controller('tencentImCtrl', ['$scope', '$modalInstance',
    function($scope, $modalInstance) {
        $scope.close = function() {
            $modalInstance.close();
        };
    }
]);
